import { ClientApiConfig } from '@quadminds/client-apis/base';
// Extend config here
export interface UsersApiConfig extends ClientApiConfig {
    accessToken?: string;
}
